module.exports = __webpack_public_path__ + "img/loginlog.e039ad52.png";